__turbopack_context__.v({
  "error-msg": "otpInput-module-scss-module__hwZpaa__error-msg",
  "error-msg-hide": "otpInput-module-scss-module__hwZpaa__error-msg-hide",
  "otp-group": "otpInput-module-scss-module__hwZpaa__otp-group",
  "otp-input": "otpInput-module-scss-module__hwZpaa__otp-input",
  "otp-input--special": "otpInput-module-scss-module__hwZpaa__otp-input--special",
  "otp-input-error": "otpInput-module-scss-module__hwZpaa__otp-input-error",
});
